/**
 * Utility module for managing offline queries cache keys in localStorage.
 * Provides consistent key generation and validation for React Query persister.
 */

// The prefix for offline queries cache entries
const OFFLINE_QUERIES_PREFIX = 'offline-queries';

/**
 * Generates a cache key for offline queries based on program and advocate IDs
 * @param programId - The program ID
 * @param advocateId - The advocate ID
 * @returns The generated cache key
 */
export const generateOfflineQueriesKey = (
  programId: string | number,
  advocateId: string | number
): string => {
  return `${OFFLINE_QUERIES_PREFIX}-${programId}-${advocateId}`;
};

/**
 * Checks if a localStorage key is an offline queries cache entry
 * @param key - The localStorage key to check
 * @returns True if the key matches the offline queries prefix
 */
export const isOfflineQueriesKey = (key: string): boolean => {
  return key.startsWith(`${OFFLINE_QUERIES_PREFIX}-`);
};

/**
 * Gets the prefix used for offline queries cache entries
 * @returns The offline queries prefix
 */
export const getOfflineQueriesPrefix = (): string => {
  return OFFLINE_QUERIES_PREFIX;
};
